// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"6":"aabf87de","98":"aabf87de","622":"aabf87de"}[chunkId] + ".css";
};